<template>
  <div class="main_theme" id="home">
    <div class="title"></div>
    <div class="describe">NeMo: <u>Ne</u>edle in a <u>Mo</u>ntage <br />for Video-Language Understanding</div>
    <!-- <br /><br /> -->
    <div class="institution_describe">
      Zi-Yuan Hu<sup>&dagger;1</sup>, Shuo Liang<sup>&dagger;1</sup>, Duo Zheng<sup>1</sup>,<br /> Yanyang Li<sup>1</sup>, Yeyao Tao<sup>1</sup>, Shijia Huang<sup>1</sup>,<br /> 
      Wei Feng<sup>2</sup>, Jia Qin<sup>2</sup>, Jianguang Yu<sup>2</sup>, Jing Huang<sup>3</sup>,<br /> Meng Fang<sup>4</sup>, Yin Li<sup>5</sup>, Liwei Wang<sup>*1</sup>
    </div>
    <!-- <br /> -->
    <div class="institution_describe institution_describe_bottom">
      <sup>1</sup>The Chinese University of Hong Kong<br /> <sup>2</sup>Phoenix TV<br />
      <sup>3</sup>Standford University<br /> <sup>4</sup>University of Liverpool<br /> <sup>5</sup>University of Wisconsin-Madison<br />
      <sup>&dagger;</sup>Equal Contributions&nbsp;&nbsp;<br />
      <sup>*</sup>Project Lead & Corresponding Author
    </div>
    <div class="institution"></div>
    <div class="button_group">
      <div class="btn lf" @click="setActive(3)">Leaderboard</div>
      <a
        href="https://arxiv.org/abs/2509.24563"
        target="_blank"
        class="btn rt"
        style="text-decoration: none !important"
        >Technical Report</a
      >
    </div>
    <div class="arrow" @click="setActive(1)"></div>
  </div>
</template>

<script>
export default {
  name: "HomeHeader",
  methods: {
    setActive(index) {
      this.$emit("setActive", index);
    },
  },
};
</script>

<style lang="scss" scoped>
$tablet: 1024px; // 平板及以下（≤1024px）
$mobile: 768px; // 移动端及以下（≤768px）

.main_theme {
  background: url("../../assets/images/mobile/Background.png") no-repeat;
  background-size: 100% 100%;
  width: calc(100% - 30px);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 15px;
  position: relative;
  padding: 40px 0;

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 60px;
    color: #ffffff;
    text-align: center;
    font-style: normal;
    margin-top: 30px;
    overflow: hidden;
    line-height: 1;
  }

  .describe {
    width: 100%;
    max-width: 932px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 50px;
    color: #ffffff;
    text-align: center;
    font-style: normal;
    margin-top: 35px;
    overflow: hidden;
    line-height: 1.2; // 优化行高避免文字重叠
  }

  .institution {
    background: url("../../assets/images/logo.png") no-repeat;
    background-size: contain; // 适应容器大小
    background-position: center;
    width: 470px;
    height: 60px;
    margin-top: 45px;
  }

  .institution_describe {
    width: 100%;
    max-width: 932px;
    font-family: PingFangSC, PingFang SC;
    font-size: 20px;
    color: #ffffff;
    text-align: center;
    font-style: normal;
    padding: 0 20px; // 增加内边距避免文字贴边
    line-height: 1.5; // 优化行高提升可读性
    margin-top: 46px;
    &.institution_describe_bottom {
      margin-top: 22px;
    }
  }

  .institution_describe a {
    color: inherit;
    text-decoration: none;
  }

  .institution_describe a:hover {
    text-decoration: underline;
  }

  .button_group {
    margin-top: 39px;
    display: flex;
    align-items: center;
    text-decoration: none !important;
    flex-shrink: 0;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    padding: 0 20px; // 增加内边距

    .btn {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 22px;
      color: #ffffff;
      line-height: 30px;
      text-align: center;
      font-style: normal;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: background-color 0.3s ease, color 0.3s ease;
      margin: 10px;
      width: 290px;
      height: 60px;
      background: rgba(255, 255, 255, 0.15);
      border: 2px solid #ffffff;
      border-radius: 8px; // 增加圆角提升美观度
    }

    .btn:hover {
      background: rgba(255, 255, 255, 0.35);
    }
  }

  .arrow {
    background: url("../../assets/images/down.png") no-repeat;
    background-size: 100% 100%;
    width: 42px;
    height: 43px;
    cursor: pointer;
    margin-top: 69px;
    animation: moveArrow 1.2s infinite alternate ease-in-out;
    z-index: 1;
  }
}

@keyframes moveArrow {
  0% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(30px);
  }
}

@media (max-width: $tablet) {
  .main_theme {
    .title {
      font-size: 50px; // 缩小标题字体
    }

    .describe {
      font-size: 40px; // 缩小描述字体
      margin-top: 25px;
    }

    .institution {
      width: 400px; // 缩小logo宽度
      height: 50px;
      margin-top: 35px;
    }

    .institution_describe {
      font-size: 18px; // 缩小机构文字
    }

    .button_group .btn {
      width: 250px; // 缩小按钮宽度
      height: 55px;
      font-size: 20px;
      margin: 8px 8px; // 垂直排列按钮
    }

    .arrow {
      margin-top: 50px;
    }
  }
}

// 移动端适配（≤768px）
@media (max-width: $mobile) {
  .main_theme {
    // padding: 40px 0; // 减少内边距

    .title {
      font-size: 36px; // 进一步缩小标题
      margin-top: 20px;
    }

    .describe {
      font-size: 28px; // 适配移动端的描述字体
      margin-top: 20px;
    }

    .institution {
      width: 80%; // 按百分比适配
      max-width: 300px;
      height: 40px;
      margin-top: 30px;
    }

    .institution_describe {
      font-size: 14px; // 移动端文字大小
      line-height: 1.6; // 增加行高提升可读性
    }

    .button_group {
      margin-top: 20px;

      .btn {
        width: 90%; // 按钮占满宽度
        max-width: 290px;
        font-size: 18px;
        height: 50px;
        margin: 8px 8px; // 垂直排列按钮
      }
    }

    .arrow {
      margin-top: 40px;
      width: 32px;
      height: 33px; // 缩小箭头
    }
  }
}
</style>
